export const EVENT_DELIVERY_PATHS = {
  CLIENT_TO_WORKER: 'client-to-worker',
  WORKER_TO_CLIENT: 'worker-to-client',
  WORKER_TO_MASTER: 'worker-to-master',
  MASTER_TO_WORKER: 'master-to-worker',
  MASTER_TO_MASTER: 'master-to-master',
  // will not be monitored
  MASTER_TO_SUPPORT_OPERATOR: 'master-to-support-operator',
  MASTER_TO_ADMIN_UI: 'master-to-admin-ui'
};

export const ENABLED_DELIVERY_MONITOR_EVENT_PATHS = {
  [EVENT_DELIVERY_PATHS.CLIENT_TO_WORKER]: false,
  [EVENT_DELIVERY_PATHS.WORKER_TO_CLIENT]: false,
  [EVENT_DELIVERY_PATHS.WORKER_TO_MASTER]: true,
  [EVENT_DELIVERY_PATHS.MASTER_TO_WORKER]: true,
  [EVENT_DELIVERY_PATHS.MASTER_TO_MASTER]: true,
  // will not be monitored
  [EVENT_DELIVERY_PATHS.MASTER_TO_SUPPORT_OPERATOR]: false,
  [EVENT_DELIVERY_PATHS.MASTER_TO_ADMIN_UI]: false
};
